import "antd/es/tabs/style";
import _Tabs from "antd/es/tabs";
var _excluded = ["tabName", "type", "draggable"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useRef } from 'react';
import Core from '../../index';
var TabPane = _Tabs.TabPane;
var dragType = 'DraggableTabNode';

var DraggableTabNode = function DraggableTabNode(_ref) {
  var index = _ref.index,
      children = _ref.children,
      moveNode = _ref.moveNode;
  var ref = useRef(null);

  var _useDrop = useDrop({
    accept: dragType,
    collect: function collect(monitor) {
      var _ref2 = monitor.getItem() || {},
          dragIndex = _ref2.index;

      if (dragIndex === index) {
        return {};
      }

      return {
        isOver: monitor.isOver(),
        dropClassName: 'dropping'
      };
    },
    drop: function drop(item) {
      moveNode(item.index, index);
    }
  }),
      _useDrop2 = _slicedToArray(_useDrop, 2),
      _useDrop2$ = _useDrop2[0],
      isOver = _useDrop2$.isOver,
      dropClassName = _useDrop2$.dropClassName,
      drop = _useDrop2[1];

  var _useDrag = useDrag({
    type: dragType,
    item: {
      index: index
    },
    collect: function collect(monitor) {
      return {
        isDragging: monitor.isDragging()
      };
    }
  }),
      _useDrag2 = _slicedToArray(_useDrag, 2),
      drag = _useDrag2[1];

  drop(drag(ref));
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    style: {
      marginRight: 2
    },
    className: isOver ? dropClassName : ''
  }, children);
};

var TabList = function TabList(_ref3) {
  var _ref3$displayList = _ref3.displayList,
      displayList = _ref3$displayList === void 0 ? [] : _ref3$displayList,
      listData = _ref3.listData,
      changeList = _ref3.changeList,
      schema = _ref3.schema,
      deleteItem = _ref3.deleteItem,
      copyItem = _ref3.copyItem,
      addItem = _ref3.addItem,
      moveItemUp = _ref3.moveItemUp,
      moveItemDown = _ref3.moveItemDown,
      displayType = _ref3.displayType,
      getFieldsProps = _ref3.getFieldsProps;

  var _useState = useState('0'),
      _useState2 = _slicedToArray(_useState, 2),
      activeKey = _useState2[0],
      setActiveKey = _useState2[1];

  var _schema$props = schema.props,
      props = _schema$props === void 0 ? {} : _schema$props,
      itemProps = schema.itemProps;

  var tabName = props.tabName,
      type = props.type,
      _props$draggable = props.draggable,
      draggable = _props$draggable === void 0 ? false : _props$draggable,
      restProps = _objectWithoutProperties(props, _excluded);

  var onEdit = function onEdit(targetKey, action) {
    if (action === 'add') {
      var currentKey = addItem();
      setActiveKey("".concat(currentKey));
    } else if (action === 'remove') {
      deleteItem(Number(targetKey));
      setActiveKey("".concat(targetKey > 1 ? targetKey - 1 : 0));
    } else {
      return null;
    }
  }; //  如果tabName传数组是可以「自定义」tab页的名字的。表单联动可以使用formrender的watch 配合 setSchemaByPath


  var getCurrentTabPaneName = function getCurrentTabPaneName(idx) {
    return tabName instanceof Array ? tabName[idx] || idx + 1 : "".concat(tabName || '项目', " ").concat(idx + 1);
  };

  return /*#__PURE__*/React.createElement(_Tabs, _extends({
    type: type || 'line',
    onChange: setActiveKey,
    activeKey: activeKey,
    onEdit: onEdit
  }, restProps), displayList.map(function (item, idx) {
    var fieldsProps = getFieldsProps(idx);
    fieldsProps.displayType = displayType;
    return /*#__PURE__*/React.createElement(TabPane, {
      tab: getCurrentTabPaneName(idx),
      key: "".concat(idx)
    }, /*#__PURE__*/React.createElement(Core, fieldsProps));
  }));
};

export default TabList;